import React from "react";
function GeneralConversation() {
  return (
    <div id="bot-scene-container" className="">
      <div id="bot-scene-content" className="scroll-light">
        <div className="app-v3-conversation--general--header">
          <div className="app-v3-conversation--general--header--title">
            Cấu hình chung
          </div>
          <div className="app-v3-conversation--general--header--actions">
            <button
              disabled={true}
              type="button"
              className="app-btn app-btn-default app-v3-btn--h-36 app-v3-conversation--general--header--actions--cancel"
            >
              Huỷ
            </button>
            <button
              type="button"
              className="app-btn app-btn-primary app-btn-action app-v3-btn--h-36 app-v3-conversation--general--header--actions--save"
            >
              <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
                <path
                  fill="#fff"
                  fillRule="evenodd"
                  d="M11.727 2.393A1.338 1.338 0 0010.78 2H3.333C2.593 2 2 2.6 2 3.333v9.334C2 13.4 2.6 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667V5.22c0-.353-.14-.693-.393-.94l-1.88-1.887zM8 12.667c-1.107 0-2-.894-2-2 0-1.107.893-2 2-2s2 .893 2 2c0 1.106-.893 2-2 2zM4.667 6h4C9.4 6 10 5.4 10 4.667c0-.734-.6-1.334-1.333-1.334h-4c-.734 0-1.334.6-1.334 1.334C3.333 5.4 3.933 6 4.667 6z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <span>Lưu</span>
            </button>
          </div>
        </div>

        <div className="app-v3-layout-content app-v3-layout-content--scroll">
          <div className="app-v3-layout-content__general">
            <div className="app-v3-conversation--general--item">
              <div className="app-v3-conversation--general--item--content">
                <div className="app-v3-conversation--general--item--content__title">
                  Tự động cập nhật trạng thái đơn hàng: Đã xác thực
                </div>
                <div className="app-v3-conversation--general--item--content__desc">
                  Hệ thống sẽ tự động chuyển trạng thái của toàn bộ đơn hàng
                  sang Đã xác thực.
                </div>
              </div>
              <div className="app-v3-conversation--general--item--action">
                <button type="button" className="app-switch app-switch-checked">
                  <span className="app-switch-inner"></span>
                  <div className="app-click-animating-node"></div>
                </button>
              </div>
            </div>

            <div className="app-v3-conversation--general--item app-v3-conversation--general--item__has-warning">
              <div className="app-v3-conversation--general--item__container">
                <div className="app-v3-conversation--general--item--content">
                  <div className="app-v3-conversation--general--item--content__title">
                    Tự động gửi thông báo xác nhận đơn hàng
                  </div>
                  <div className="app-v3-conversation--general--item--content__desc">
                    Hệ thống sẽ gửi thông báo xác nhận đơn hàng cho khách hàng
                    khi có đơn hàng được tạo.
                  </div>
                  <div className="app-v3-conversation--general--item__block__facebook">
                    <div className="app-v3-conversation--general--item--content__title">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="url(#paint0_radial_344_519)"
                          fillRule="evenodd"
                          d="M12.047 1.5C6.105 1.5 1.5 5.852 1.5 11.73c0 3.075 1.26 5.732 3.312 7.567.173.155.277.37.284.602l.057 1.876a.844.844 0 001.184.746l2.094-.924a.842.842 0 01.563-.042c.962.265 1.986.406 3.053.406 5.941 0 10.547-4.352 10.547-10.23 0-5.879-4.606-10.231-10.547-10.231z"
                          clipRule="evenodd"
                        />
                        <path
                          fill="#fff"
                          fillRule="evenodd"
                          d="M5.714 14.722l3.098-4.915a1.582 1.582 0 012.287-.422l2.464 1.848c.226.17.537.169.763-.002l3.328-2.526c.444-.337 1.023.195.726.666l-3.098 4.916a1.582 1.582 0 01-2.287.422L10.53 12.86a.633.633 0 00-.762.002L6.44 15.389c-.444.337-1.024-.195-.726-.667z"
                          clipRule="evenodd"
                        />
                        <defs>
                          <radialGradient
                            id="paint0_radial_344_519"
                            cx="0"
                            cy="0"
                            r="1"
                            gradientTransform="matrix(22.9837 0 0 22.9836 5.56 22.48)"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#09F" />
                            <stop offset="0.61" stopColor="#A033FF" />
                            <stop offset="0.935" stopColor="#FF5280" />
                            <stop offset="1" stopColor="#FF7061" />
                          </radialGradient>
                        </defs>
                      </svg>
                      <span className="app-v3-conversation--general--item--content__title-item">
                        Kênh Facebook
                      </span>
                    </div>

                    <div className="app-v3-conversation--general--item__block__item">
                      <div className="app-v3-conversation--general--item__block-confirm">
                        <div className="app-v3-conversation--general--item__content">
                          <div className="app-v3-conversation--general--item--content__title">
                            Cho phép gửi mẫu xác nhận đơn hàng qua kênh Facebook
                          </div>
                        </div>
                        <div className="app-v3-conversation--general--item--action">
                          <button
                            type="button"
                            className="app-switch app-switch-checked"
                          >
                            <span className="app-switch-inner"></span>
                            <div className="app-click-animating-node"></div>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="app-v3-conversation--general--item__block__item">
                      <div className="radio-btn-template-order-confirm-fb-channel">
                        <div className="app-next-input-radio">
                          <label
                            className="app-next-label--switch"
                            htmlFor="app-v3-group-radio-template-order-confirm-fb-channelapp-v3-group-radio-template-order-confirm-fb-channel0"
                          >
                            <div className="app-v3-conversation--general--item__block-confirm">
                              <div className="app-v3-conversation--general--item__content">
                                <div className="app-v3-conversation--general--item--content__title">
                                  Mẫu xác nhận đơn hàng của Viettel Media
                                  <div className="app-v3-conversation--general--item--content__title--tooltip">
                                    <svg
                                      width="16"
                                      height="16"
                                      fill="none"
                                      viewBox="0 0 20 20"
                                    >
                                      <path
                                        fill="currentColor"
                                        fillRule="evenodd"
                                        d="M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm-.833 14.166v-1.666h1.666v1.666H9.167zm2.641-5.691l.75-.767c.85-.85 1.142-2.308.159-3.667-.75-1.041-1.959-1.7-3.225-1.5A3.34 3.34 0 006.8 6.567c-.133.466.2.933.683.933h.25c.325 0 .584-.233.684-.542A1.68 1.68 0 0110.475 5.9c.583.167 1.05.675 1.158 1.275.109.583-.075 1.133-.458 1.5l-1.033 1.05a3.332 3.332 0 00-.975 2.358v.417h1.666c0-.383.042-.683.109-.95.15-.6.45-.983.866-1.408z"
                                        clipRule="evenodd"
                                      ></path>
                                    </svg>
                                  </div>
                                </div>
                                <div className="app-v3-conversation--general--item--content__desc">
                                  Mẫu xác nhận sẽ được gửi nếu đơn hàng được tạo
                                  thành công. Gợi ý: Bạn nên sử dụng mẫu xác
                                  nhận đơn hàng của Viettel Media để có đầy đủ thông
                                  tin chi tiết đơn hàng.
                                </div>
                              </div>
                            </div>
                          </label>
                          <input
                            id="app-v3-group-radio-template-order-confirm-fb-channelapp-v3-group-radio-template-order-confirm-fb-channel0"
                            name="app-v3-group-radio-template-order-confirm-fb-channel"
                            type="radio"
                            className="app-next-radio"
                            value="1"
                            defaultChecked={true}
                          />
                          <span className="app-next-radio--styled"></span>
                        </div>
                        <div className="app-next-input-radio">
                          <label
                            className="app-next-label--switch"
                            htmlFor="app-v3-group-radio-template-order-confirm-fb-channelapp-v3-group-radio-template-order-confirm-fb-channel1"
                          >
                            <div className="app-v3-conversation--general--item__block-confirm">
                              <div className="app-v3-conversation--general--item__content">
                                <div className="app-v3-conversation--general--item--content__title">
                                  Mẫu xác nhận đơn hàng của Facebook
                                  <div className="app-v3-conversation--general--item--content__title--tooltip">
                                    <svg
                                      width="16"
                                      height="16"
                                      fill="none"
                                      viewBox="0 0 20 20"
                                    >
                                      <path
                                        fill="currentColor"
                                        fillRule="evenodd"
                                        d="M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm-.833 14.166v-1.666h1.666v1.666H9.167zm2.641-5.691l.75-.767c.85-.85 1.142-2.308.159-3.667-.75-1.041-1.959-1.7-3.225-1.5A3.34 3.34 0 006.8 6.567c-.133.466.2.933.683.933h.25c.325 0 .584-.233.684-.542A1.68 1.68 0 0110.475 5.9c.583.167 1.05.675 1.158 1.275.109.583-.075 1.133-.458 1.5l-1.033 1.05a3.332 3.332 0 00-.975 2.358v.417h1.666c0-.383.042-.683.109-.95.15-.6.45-.983.866-1.408z"
                                        clipRule="evenodd"
                                      ></path>
                                    </svg>
                                  </div>
                                </div>
                                <div className="app-v3-conversation--general--item--content__desc">
                                  Mẫu xác nhận sẽ được gửi nếu đơn hàng được tạo
                                  thành công.
                                </div>
                              </div>
                            </div>
                          </label>
                          <input
                            id="app-v3-group-radio-template-order-confirm-fb-channelapp-v3-group-radio-template-order-confirm-fb-channel1"
                            name="app-v3-group-radio-template-order-confirm-fb-channel"
                            type="radio"
                            className="app-next-radio"
                            value="2"
                          />
                          <span className="app-next-radio--styled"></span>
                        </div>
                      </div>
                    </div>

                    <div className="app-v3-conversation--general--item__block__item">
                      <div className="app-v3-conversation--general--item__block-confirm">
                        <div className="app-v3-conversation--general--item__content">
                          <div className="app-v3-conversation--general--item--content__title">
                            Mẫu xác nhận đơn hàng gộp đơn Livestream
                            <div className="app-v3-conversation--general--item--content__title--tooltip">
                              <svg
                                width="16"
                                height="16"
                                fill="none"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fill="currentColor"
                                  fillRule="evenodd"
                                  d="M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm-.833 14.166v-1.666h1.666v1.666H9.167zm2.641-5.691l.75-.767c.85-.85 1.142-2.308.159-3.667-.75-1.041-1.959-1.7-3.225-1.5A3.34 3.34 0 006.8 6.567c-.133.466.2.933.683.933h.25c.325 0 .584-.233.684-.542A1.68 1.68 0 0110.475 5.9c.583.167 1.05.675 1.158 1.275.109.583-.075 1.133-.458 1.5l-1.033 1.05a3.332 3.332 0 00-.975 2.358v.417h1.666c0-.383.042-.683.109-.95.15-.6.45-.983.866-1.408z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                          </div>
                          <div className="app-v3-conversation--general--item--content__desc">
                            Mẫu xác nhận sẽ được gửi nếu đơn hàng là đơn được
                            gộp từ nhiều đơn hàng hợp lệ của cùng khách hàng
                            trong các phiên livestream.
                          </div>
                        </div>
                        <div className="app-v3-conversation--general--item--action">
                          <button type="button" className="app-switch">
                            <span className="app-switch-inner"></span>
                            <div className="app-click-animating-node"></div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="app-v3-conversation--general--item__block__item"></div>
                </div>
              </div>
            </div>

            <div className="app-v3-conversation--general--item">
              <div className="app-v3-conversation--general--item--content">
                <div className="app-v3-conversation--general--item--content__title">
                  Có âm thanh thông báo tin nhắn mới
                </div>
                <div className="app-v3-conversation--general--item--content__desc">
                  Hệ thống sẽ tự động phát ra âm thanh thông báo khi có tin nhắn
                  mới.
                </div>
              </div>
              <div className="app-v3-conversation--general--item--action">
                <button type="button" className="app-switch">
                  <span className="app-switch-inner"></span>
                  <div className="app-click-animating-node"></div>
                </button>
              </div>
            </div>

            <div className="app-v3-conversation--general--item">
              <div className="app-v3-conversation--general--item--content">
                <div className="app-v3-conversation--general--item--content__title">
                  Hệ thống tự động đồng bộ hội thoại trong thư mục Spam (tin
                  nhắn rác)
                </div>
                <div className="app-v3-conversation--general--item--content__desc">
                  Hệ thống sẽ tự động đồng bộ hội thoại trong thư mục Spam từ
                  Facebook.
                </div>
              </div>
              <div className="app-v3-conversation--general--item--action">
                <button type="button" className="app-switch app-switch-checked">
                  <span className="app-switch-inner"></span>
                  <div className="app-click-animating-node"></div>
                </button>
              </div>
            </div>

            <div className="app-v3-conversation--general--item__block--topic">
              <div className="app-v3-conversation--general--item__content--topic">
                <div className="app-v3-conversation--general--item--content">
                  <div className="app-v3-conversation--general--item--content__title">
                    <div className="app-v3-conversation--general--item--content__title--item">
                      Tự động gửi lời mời khách hàng nhận thông báo định kỳ sau
                      khi tạo đơn hàng
                      <a
                        href=""
                        target="_blank"
                      >
                        <svg
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="currentColor"
                            fillRule="evenodd"
                            d="M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm-.833 14.166v-1.666h1.666v1.666H9.167zm2.641-5.691l.75-.767c.85-.85 1.142-2.308.159-3.667-.75-1.041-1.959-1.7-3.225-1.5A3.34 3.34 0 006.8 6.567c-.133.466.2.933.683.933h.25c.325 0 .584-.233.684-.542A1.68 1.68 0 0110.475 5.9c.583.167 1.05.675 1.158 1.275.109.583-.075 1.133-.458 1.5l-1.033 1.05a3.332 3.332 0 00-.975 2.358v.417h1.666c0-.383.042-.683.109-.95.15-.6.45-.983.866-1.408z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </a>
                    </div>
                  </div>
                  <div className="app-v3-conversation--general--item--content__desc--topic">
                    Hệ thống sẽ tự động gửi lời mời khách hàng nhận thông tin về
                    cửa hàng định kỳ sau khi tạo đơn hàng.
                  </div>
                </div>
                <div className="app-v3-conversation--general--item--action">
                  <button type="button" className="app-switch">
                    <span className="app-switch-inner"></span>
                    <div className="app-click-animating-node"></div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GeneralConversation;
